<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Analytics
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Active Keys Report</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-signal me-1" style="color: #00A0C1;"></i>
                  Extension keys that have been active within the past 30 days.
               </small>
            </div>
         </div>
      </div>

      <ActiveKeys />
   </div>
</template>

<script>
import ActiveKeys from '@/components/Analytics/Active Keys/ActiveKeys.vue';

export default {
   components: { ActiveKeys },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>